import Box from "../components/box";
import Btn from "../components/btn";
import Input from "../components/input";
import Spinner from "../components/spinner";
import h from "../core/createElement";
import Modal from "../core/modalEngine";
import popupAlerts from "../core/popupAlerts";
import group_service from "../service/group_service";
import { switchable_element } from "../utils";


function Group({ hide, created }) {
    const
        shared = {},
        loading = switchable_element(<Spinner />);

    const create_new_group = async () => {
        try {
            const name = shared.name.value;

            if (name == "" || name.length < 4 || name.length > 64) {
                shared.name.invalid(true);
                return popupAlerts.warning("Preencha corretamente o campo!");
            };

            loading.show();

            const { data } = await group_service.create({ name });

            loading.hide();

            hide(() => created && created(data.data))
        } catch (e) {
            loading.hide();
        };
    };

    return (
        <Box title="Novo grupo" containerClass="modal-group-box" buttons={<Btn icon="assets/image/x_white.svg" onClick={() => hide()} color="red" />}>
            <section class="flex-column flex-1 group-form-content">
                <Input title="Nome" name="name" containerClass="flex-1" shared={shared} placeholder="Entre 4 e 64 caracteres" />

                <section class="flex save-btn-container">
                    <Btn title="Salvar" color="green" name="save_btn" shared={shared} onClick={create_new_group} />
                </section>
            </section>
            {loading.marker()}
        </Box>
    );
};

const GroupModal = new Modal(Group);

export default GroupModal;